// extracted by mini-css-extract-plugin
export default {"cls1":"QcZVbH5gZn_vl8wOLssZ","cls2":"j4v7XJcPykVWGB020yrY QcZVbH5gZn_vl8wOLssZ"};